export const SET_CAT_SUBJECT = 'cat/SET_CAT_SUBJECT';
export const SET_CAT_DOMAIN = 'cat/SET_CAT_DOMAIN';
export const SET_ACTIVE_ASSIGNMENT = 'cat/SET_ACTIVE_ASSIGNMENT';
export const SET_CAT_CONFIGS = 'cat/SET_CAT_CONFIGS';
export const SET_PROFICIENCY_HISTORY = 'cat/SET_PROFICIENCY_HISTORY';
export const SET_FILTER_PROFICIENCY_HISTORY = 'cat/SET_FILTER_PROFICIENCY_HISTORY';
export const SET_FILTER_PROFICIENCY_RANK = 'cat/SET_FILTER_PROFICIENCY_RANK';
export const SET_SELECTED_SUBJECT_ID = 'cat/SET_SELECTED_SUBJECT_ID';
export const SET_CHILD_PROFICIENCY_HISTORY = 'cat/SET_CHILD_PROFICIENCY_HISTORY';
export const SET_CHILD_PROFICIENCY_RANK = 'cat/SET_CHILD_PROFICIENCY_RANK';
export const SET_SELECTED_CHILD = 'cat/SET_SELECTED_CHILD';
export const SET_VIDEO_LECTURES = 'cat/SET_VIDEO_LECTURES';
export const SET_CARD_LECTURES = 'cat/SET_CARD_LECTURES';
export const SET_SELECTED_LECTURE_SUBJECT_ID = 'cat/SET_SELECTED_LECTURE_SUBJECT_ID';
export const SET_SUBJECTS = 'cat/SET_SUBJECTS';
export const SET_RECOMMEND_VIDEO_LECTURES = 'video-lectures/SET_RECOMMEND_VIDEO_LECTURES';
export const SET_RECOMMEND_CARD_LECTURES = 'card-lectures/SET_RECOMMEND_CARD_LECTURES';
export const SET_BUSY = 'cat/SET_BUSY';
export const SET_COUNTRIES = 'cat/SET_COUNTRIES';
export const SET_USER_COUNTRY = 'cat/SET_USER_COUNTRY';



// WEBPACK FOOTER //
// ./src/app/cat-main/store/mutation-types.js